import { createContext, useContext, useEffect, useState } from 'react';
import { fr } from './locales/fr';
import { en } from './locales/en';

const translations = { fr, en };

const LanguageContext = createContext(null);

const STORAGE_KEY = 'swiftai-lang';

function getInitialLang() {
  if (typeof window === 'undefined') return 'fr';
  const saved = window.localStorage.getItem(STORAGE_KEY);
  if (saved === 'fr' || saved === 'en') return saved;
  const browser = window.navigator.language?.slice(0, 2).toLowerCase();
  return browser === 'en' ? 'en' : 'fr';
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(getInitialLang);

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const toggleLang = () => setLang((l) => (l === 'fr' ? 'en' : 'fr'));

  const value = {
    lang,
    setLang,
    toggleLang,
    t: translations[lang],
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useLang() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLang must be used inside a LanguageProvider');
  return ctx;
}
